import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DocketRow } from "../../utilities/interfaces/DocketRow";
import { docketApi } from "../../utilities/api/docketApi";

interface docketState {
  rows: DocketRow[];
  fetchingRows: boolean;
}

const initialState: docketState = {
  rows: [],
  fetchingRows: false,
}

const docketSlice = createSlice({
  name: 'stateDocket',
  initialState,
  reducers: {
    clearDocket(state) {
      state.rows = [];
    }
  },
  extraReducers(builder) {
    builder.addCase(getDocketRows.pending, (state) => {
      state.fetchingRows = true;
    })
    builder.addCase(getDocketRows.fulfilled , (state, action: any) => {
      if (!action.payload || action.payload === null) {
        state.rows = [];
      }
      else {
        state.rows = action.payload.output;
      }
      state.fetchingRows = false;
    })
    builder.addCase(getDocketRows.rejected, (state) => {
      state.fetchingRows = false;
    })
  }
});

export const getDocketRows = createAsyncThunk('stateDocket/getDocketRows', async () => {
  const response = await docketApi.getDocket();
  return response;
});

export const { clearDocket } = docketSlice.actions;
export default docketSlice.reducer;